import { apiRoutes } from '../../routes/api-routes';
import { api } from '../../shared/api/client';
import { sessionApi } from '../../shared/api/http';
import { ensureOk, unwrap } from '../../shared/api/problem';
import { exclusive, session } from '../../shared/api/session';

/** Takes its turn with refreshes in other tabs, so a late refresh answer cannot erase the new cookie. */
export async function signIn(email: string, password: string): Promise<void> {
  const answer = await exclusive(() => sessionApi.POST(apiRoutes.auth.login, { body: { email, password } }));
  session.start(unwrap(answer));
}

export async function signOut(): Promise<void> {
  try {
    ensureOk(await api.POST(apiRoutes.auth.logout));
  } finally {
    // Signed out locally even if the server could not be reached.
    session.clear();
  }
}
